module.exports = __webpack_public_path__ + "static/media/not-found-dark.7fb87618.svg";